import React from 'react';

import RegionsContainer from '@totem/components/portfolio/regions/list/RegionsContainer';
import RegionsLayout, {
  RegionsExtra,
} from '@totem/components/portfolio/regions/list/RegionsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const RegionsPage = () => (
  <ContentLayout>
    <RegionsContainer>
      <IBCard isCovered title="Region Management" extra={<RegionsExtra />}>
        <RegionsLayout />
      </IBCard>
    </RegionsContainer>
  </ContentLayout>
);

export default RegionsPage;
